import { FC, PropsWithChildren, useMemo } from 'react';
import { Box, Container } from '@mui/material';
import { userModel } from 'entities/user';
import { userActions } from 'entities/user/model';
import {
  checkRequestStatusEquality,
  COLOR_GRADIENT_BG,
  flexHelper,
  RequestStatus,
  Spinner,
  uiSelector,
  useShallowSelector,
} from 'shared';

import { Footer } from './footer';
import { Header } from './header';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  const { address } = useShallowSelector(userModel.selectors.selectUserWeb3Info);
  const uiState = useShallowSelector(uiSelector);
  const isGetKycRequest = checkRequestStatusEquality(
    uiState[userActions.getIsKycApproved?.type],
    RequestStatus.REQUEST,
  );
  const isShowSpinner = useMemo(
    () => address && (isGetKycRequest || !uiState[userActions.getIsKycApproved?.type]),
    [address, isGetKycRequest, uiState],
  );
  return (
    <Box
      sx={{
        background: COLOR_GRADIENT_BG,
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header />
      <Container
        sx={{
          flex: 1,
        }}
      >
        {isShowSpinner ? (
          <Spinner
            sx={{
              width: '100%',
              height: '100%',
              minHeight: '50vh',
              ...flexHelper('center', 'center'),
              mt: { xs: 4, md: 20 },
            }}
          />
        ) : (
          children
        )}
      </Container>
      <Footer />
    </Box>
  );
};
